import script from "./VitaVacationControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaVacationControl.vue?vue&type=script&setup=true&lang=ts"

import "./VitaVacationControl.vue?vue&type=style&index=0&id=01339c5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01339c5e"]])

export default __exports__